module.exports = __webpack_public_path__ + "static/media/candle-placeholder.c52a5fbf.png";